const styles = {
  root: {},
  imageContainer: {
    position: 'relative',
    height: { xs: 400, lg: 450 },
    width: '100%',
    '& img': {
      borderRadius: 2,
    },
  },
  content: {
    '*': {
      fontFamily: 'Poppins',
    },
  },
}
export default styles
